import React , {Component} from 'react';
import {
    Page  , Link
} from 'framework7-react';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";

class City extends Component{



    onPageBeforeIn(){
        this.props.toolbar(false)
    }




    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        this.setState({ fields:fields})

        localStorage.setItem('city' , "1")
        if (this.state.fields.city === "بابل"){
            localStorage.setItem('city' , "1")
        }
        else if (this.state.fields.city === "ساری"){
            localStorage.setItem('city' , "2")
        }
        else if (this.state.fields.city === "قائمشهر"){
            localStorage.setItem('city' , "3")
        }
        else if (this.state.fields.city === "بابلسر"){
            localStorage.setItem('city' , "4")
        }
        else if (this.state.fields.city === "آمل"){
            localStorage.setItem('city' , "5")
        }
        else {
            localStorage.setItem('city' , "6")
        }

    }



    constructor(props){
        super(props)

        localStorage.setItem('city' , "1")
        let qq = 'بابل'
        if (localStorage.getItem('city' ) !== undefined && parseInt(localStorage.getItem('city' )) > 0)
        {
            if (localStorage.getItem('city') === "1"){
                qq = 'بابل'
            }
            else if (localStorage.getItem('city') === "2"){
                qq = 'ساری'
            }
            else if (localStorage.getItem('city') === "3"){
                qq = 'قائمشهر'
            }
            else if (localStorage.getItem('city') === "4"){
                qq = 'بابلسر'
            }
            else if (localStorage.getItem('city') === "5"){
                qq = 'آمل'
            }

        }

        this.state = {
            fields : {
                city : qq,
            } ,

        }
    }
    handleSubmit(event){

        event.preventDefault()
        this.$f7router.navigate('/')
        return false
    }

    render(){

        return(
            <Page name="city" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>



                <div id="city">


                    <div id="header">
                        <img src="https://www.lavefood.com/webappassets/images/select-location.jpg" />
                    </div>



                    <img src="https://www.lavefood.com/webappassets/images/logo.svg" id="logo"  />



                    <form onSubmit={this.handleSubmit.bind(this)} className="input-container pt-5">

                        <label htmlFor="phone" className="label">
                            <img src="https://www.lavefood.com/webappassets/images/city.svg" className="img"/>
                            <div className="title">
                                انتخاب شهر
                            </div>
                        </label>

                        <div className="form-group">
                            <select name="city" className="form-control input-field-2" defaultValue={this.state.fields.city} onChange={this.handleChange.bind(this)}>
                                <option value="بابل">بابل</option>
                                <option value="ساری">ساری</option>
                                <option value="قائمشهر">قائمشهر</option>
                                <option value="بابلسر">بابلسر</option>
                                <option value="آمل">آمل</option>
                            </select>
                        </div>


                        <div className="input-group">
                            <button type="submit" className="btn btn-custom-4 ">
                                 مشاهده رستوران‌های
                                {
                                    this.state.fields.city
                                }
                            </button>
                        </div>

                    </form>



                </div>









            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(City);